


export const GA_MEASUREMENT_ID = 'G-8NJX07SJ8D';

export const sendPageView = (path: string, title?: string) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    console.warn('gtag not yet available, skipping page_view');
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
};